import React from "react";
import { connect } from "react-redux";
import FilmalityCircularProgress from "../../../../shared/filmality-circular-progress";
import Makeup from "./makeup";
import Errors from "../../../../shared/errors";
import {
    OnboardingStep1ClassName,
    OnboardingStep2ClassName,
    OnboardingStep3ClassName,
    OnboardingStep4ClassName
} from "./ducks/reducer";
import Onboarding from '../../../../shared/onboarding/onboarding';
import confirm from "../../../../shared/modal/confirm";
import FilmanizeCheckbox from "../../../../shared/filmanize-checkbox";

function Overview(props) {
    const {
        overview,
        filmId,
        errors,
        warnings,
        onboardingSteps,
        aliasMakeup,
        unaliasMakeup,
        processingMakeupIds,
        deleteMultipleMakeups
    } = props;

    const readOnly = overview.readOnly;

    const [selectedMakeupIds, setSelectedMakeupIds] = React.useState<number[]>([]);

    const toggleMakeupSelection = (makeupId: number) => {
        setSelectedMakeupIds(prev =>
            prev.includes(makeupId)
                ? prev.filter(id => id !== makeupId)
                : [...prev, makeupId]
        );
    };

    const toggleSelectAll = () => {
        if (selectedMakeupIds.length === overview.makeups?.length) {
            setSelectedMakeupIds([]);
        } else {
            setSelectedMakeupIds(overview.makeups?.map(m => m.id) || []);
        }
    };

    const deleteMultipleMakeupsLocal = (filmId, selectedMakeupIds) => {
        deleteMultipleMakeups(filmId, selectedMakeupIds);
        setSelectedMakeupIds([]);
    };

    const handleDeleteSelected = () => {
        if (selectedMakeupIds.length === 0) return;
        confirm(() => deleteMultipleMakeupsLocal(filmId, selectedMakeupIds), null, `Are you sure you want to delete ${selectedMakeupIds.length} makeup${selectedMakeupIds.length !== 1 ? 's' : ''}?`, "Delete Makeups");
    };

    function MakeupList() {
        const allSelected = selectedMakeupIds.length === overview.makeups?.length && overview.makeups?.length > 0;

        return (
            <table className={`${OnboardingStep2ClassName} table`}>
                <thead>
                    <tr>
                        {!readOnly && (
                            <th>
                                <FilmanizeCheckbox
                                    checked={allSelected}
                                    onChange={toggleSelectAll}
                                />
                            </th>
                        )}
                        <th>Name</th>
                        <th>Script Days</th>
                    </tr>
                </thead>
                <tbody>
                    {(overview.makeups || []).map((makeup, index) => {
                        return (
                            <Makeup
                                key={index}
                                index={index}
                                makeup={makeup}
                                filmId={filmId}
                                readOnly={readOnly}
                                aliasMakeup={aliasMakeup}
                                unaliasMakeup={unaliasMakeup}
                                processingMakeupIds={processingMakeupIds}
                                isSelected={selectedMakeupIds.includes(makeup.id)}
                                onToggleSelect={() => toggleMakeupSelection(makeup.id)}
                            />
                        );
                    })}
                </tbody>
            </table>
        );
    }

    return (
        <div>

            {errors && <Errors errors={errors} />}
            {warnings && <Errors errors={warnings} isWarning={true} />}
            <div className={OnboardingStep1ClassName}>
                <div className="columns">
                    <div className="column">
                        <MakeupList />
                    </div>
                </div>
            </div>
            <div className="mt-1 buttons">
                {!readOnly && overview.makeups?.length > 0 && (
                    <button
                        className="button is-danger"
                        onClick={handleDeleteSelected}
                        disabled={selectedMakeupIds.length === 0}
                    >
                        Delete Selected ({selectedMakeupIds.length})
                    </button>
                )}
            </div>

            <Onboarding onboardingSteps={onboardingSteps} section="Makeup Overview" />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        onboardingSteps:
            state.makeupOverviewState.onboardingSteps
    };
}

export default connect(mapStateToProps, {
})(Overview);
